// extracted by mini-css-extract-plugin
export default {"root":"styles_root__EemLA","box":"styles_box__C7FQv"};